import { render, staticRenderFns } from "./TableView.ts.vue?vue&type=template&id=013669b3"
import script from "./TableView.ts.vue?vue&type=script&lang=ts"
export * from "./TableView.ts.vue?vue&type=script&lang=ts"
import style0 from "./TableView.ts.vue?vue&type=style&index=0&id=013669b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports